import { initializePopovers, removePopover } from "../../Shared/Popover/popover";

(() => {
  document.addEventListener("htmx:beforeOnLoad", () => {
    // Make sure to clear up any existing popovers after POSTing, since all types of POST
    // on this page modifies the existing popover.
    document.querySelectorAll<HTMLElement>("[data-popover]").forEach(removePopover);
  });
})();

htmx.onLoad(rootElement => {
  initializePopovers(rootElement);
});
